(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-grid"] && !Shopify.designMode) return;
  try {
    
  /* ── Hash scroll on page load ── */
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* ── Collection nav: IntersectionObserver + dropdown ── */
  (function () {
    if (window.__mcgNavInit) return;
    window.__mcgNavInit = true;

    function init() {
      const sections = document.querySelectorAll('[data-mcg-collection]');
      const sidebarLinks = document.querySelectorAll('[data-mcg-nav-link]');
      const dropdown = document.querySelector('[data-mcg-dropdown]');

      if (sections.length === 0) return;

      let isScrolling = false;

      function setActive(id) {
        sidebarLinks.forEach((link) => {
          if (link.dataset.mcgNavLink === id) {
            link.classList.add('mcg-nav-sidebar__link--active');
          } else {
            link.classList.remove('mcg-nav-sidebar__link--active');
          }
        });

        if (dropdown && !isScrolling) {
          dropdown.value = id;
        }
      }

      const headerHeight = parseInt(
        getComputedStyle(document.documentElement).getPropertyValue('--header-height') || '60',
        10
      );
      const rootMargin = `-${headerHeight + 80}px 0px -50% 0px`;

      const observer = new IntersectionObserver(
        (entries) => {
          let topEntry = null;
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (!topEntry || entry.boundingClientRect.top < topEntry.boundingClientRect.top) {
                topEntry = entry;
              }
            }
          });
          if (topEntry) {
            setActive(topEntry.target.id);
          }
        },
        { rootMargin, threshold: 0 }
      );

      sections.forEach((s) => observer.observe(s));

      sidebarLinks.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = link.dataset.mcgNavLink;
          const target = document.getElementById(targetId);
          if (target) {
            setActive(targetId);
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      if (dropdown) {
        dropdown.addEventListener('change', (e) => {
          const target = document.getElementById(e.target.value);
          if (target) {
            isScrolling = true;
            setActive(e.target.value);
            target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            setTimeout(() => { isScrolling = false; }, 1000);
          }
        });
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
